import { render } from "./AboutComponent.vue?vue&type=template&id=0564443e"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hhsiao\\Downloads\\Mamba\\cloud-business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__